/** 接口数据加解密 */
import JSEncrypt from "jsencrypt";

const rsaPubKey = process.env.REACT_APP_RSA_PUB_KEY;
const rsaPriKey = process.env.REACT_APP_RSA_PRI_KEY;

/**
 * RSA加密方法
 */
const encryptRSA = (word) => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(rsaPubKey); //设置公钥
  const rsaPassWord = encryptor.encrypt(word); // 对内容进行加密
  return rsaPassWord;
};
/**
 * RSA解密方法
 */
const decryptRSA = (word) => {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(rsaPriKey); //设置私钥
  return encryptor.decrypt(word);
};

export { encryptRSA, decryptRSA };



// WEBPACK FOOTER //
// ./src/helper/crypto.js